import { unpopulateWeek } from '../pages/generator/generatorUtils/populates'

const DB_NAME = 'planning-local-drafts'
const DB_VERSION = 1
const STORE_DRAFTS = 'drafts'
const SAVE_WITHOUT_LOCAL_DRAFT_CONFIRM_MESSAGE =
  "Le brouillon local n'a pas pu être enregistré. Voulez-vous quand même envoyer la sauvegarde au serveur sans copie locale ?"

let saveWithoutLocalDraftConfirmationHandler = null

export const WEEK_DRAFT_SCOPE_GENERATOR = 'generator'
export const WEEK_DRAFT_SCOPE_INDISPO = 'indispo'

const normalizeWeekDraftScope = (scope) => scope || WEEK_DRAFT_SCOPE_GENERATOR

const openDraftDb = () => {
  return new Promise((resolve, reject) => {
    const request = indexedDB.open(DB_NAME, DB_VERSION)

    request.onupgradeneeded = () => {
      const db = request.result
      if (!db.objectStoreNames.contains(STORE_DRAFTS)) {
        const store = db.createObjectStore(STORE_DRAFTS, { keyPath: 'key' })
        store.createIndex('userId', 'userId', { unique: false })
        store.createIndex('weekId', 'weekId', { unique: false })
      }
    }

    request.onsuccess = () => resolve(request.result)
    request.onerror = () => reject(request.error)
  })
}

const withDraftStore = async (mode, action) => {
  const db = await openDraftDb()

  return new Promise((resolve, reject) => {
    const transaction = db.transaction(STORE_DRAFTS, mode)
    const store = transaction.objectStore(STORE_DRAFTS)
    const request = action(store)

    request.onsuccess = () => resolve(request.result)
    request.onerror = () => reject(request.error)
    transaction.oncomplete = () => db.close()
    transaction.onerror = () => {
      db.close()
      reject(transaction.error)
    }
  })
}

export const buildWeekDraftKey = (userId, weekId, mondayISO, scope = WEEK_DRAFT_SCOPE_GENERATOR) => {
  if (!userId) return null
  const weekKey = weekId || mondayISO
  if (!weekKey) return null
  return `week:${normalizeWeekDraftScope(scope)}:${userId}:${weekKey}`
}

export const serializeWeekForDraft = (week) => {
  const nextWeek = JSON.parse(JSON.stringify(week))
  unpopulateWeek(nextWeek)
  return nextWeek
}

export const buildWeekDraft = ({ userId, route, scope = WEEK_DRAFT_SCOPE_GENERATOR, week }) => {
  if (!userId || !week) return null

  const mondayISO = new Date(week.date).toISOString()
  const draftScope = normalizeWeekDraftScope(scope)
  const key = buildWeekDraftKey(userId, week._id, mondayISO, draftScope)
  if (!key) return null

  return {
    key,
    scope: draftScope,
    userId,
    weekId: week._id || null,
    mondayISO,
    route,
    week: serializeWeekForDraft(week),
    updatedAt: new Date().toISOString(),
    serverUpdatedAt: week.updatedAt || null,
  }
}

export const putWeekDraft = (draft) => {
  if (!draft) return Promise.resolve(null)
  return withDraftStore('readwrite', (store) => store.put(draft))
}

export const getWeekDraft = (key) => {
  if (!key) return Promise.resolve(null)
  return withDraftStore('readonly', (store) => store.get(key))
}

export const deleteWeekDraft = (key) => {
  if (!key) return Promise.resolve(null)
  return withDraftStore('readwrite', (store) => store.delete(key))
}

export const setSaveWithoutLocalDraftConfirmationHandler = (handler) => {
  saveWithoutLocalDraftConfirmationHandler = handler

  return () => {
    if (saveWithoutLocalDraftConfirmationHandler === handler) {
      saveWithoutLocalDraftConfirmationHandler = null
    }
  }
}

export const confirmSaveWithoutLocalDraft = async () => {
  if (saveWithoutLocalDraftConfirmationHandler) {
    return await saveWithoutLocalDraftConfirmationHandler()
  }

  return window.confirm(SAVE_WITHOUT_LOCAL_DRAFT_CONFIRM_MESSAGE)
}
